<template>
  <el-tabs
    id="feeTab"
    v-model="activeName"
    :before-leave="checkTab"
    @tab-click="handleTabClick"
  >
    <el-tab-pane name="FeePeriodList">
      <span slot="label">期別列表</span>
    </el-tab-pane>
    <el-tab-pane name="FeePaymentList">
      <span slot="label">繳費列表</span>
    </el-tab-pane>
    <el-tab-pane
      v-if="configData.ConfigCommunityCodeRuleIsExisting"
      name="FeeDeposit"
    >
      <span slot="label">入帳報表</span>
    </el-tab-pane>
    <el-tab-pane name="FeeWriteoffErr">
      <span slot="label">異常入帳款項</span>
    </el-tab-pane>
    <!-- <el-tab-pane name="FeeWriteoff">
      <span slot="label">銷帳列表</span>
    </el-tab-pane>
    <el-tab-pane name="FeeReconcile">
      <span slot="label">對帳列表</span>
    </el-tab-pane> -->
  </el-tabs>
</template>
<script>
export default {
  props: {
    periodData: Array,
    periodDataNew: Number, // 最新期別
    configData: Object
  },
  data () {
    return {
      activeName: 'FeePeriodList',
      noPeriod: false,
      feeType: 'management'
    }
  },
  watch: {
    $route (to, from) {
      this.activeName = to.name
    },
    periodData (list) {
      // eslint-disable-next-line eqeqeq
      if (list.length == 0) { // 列表為零 其他tab設為disable
        this.noPeriod = true
        // eslint-disable-next-line eqeqeq
        if (this.$route.name != 'FeePeriodList') { // 其他頁面則導回期別列表
          this.$router.push(
            {
              name: 'FeePeriodList',
              params: { type: this.feeType }
            }
          )
        }
      } else {
        this.noPeriod = false
      }
    }
  },
  mounted () {
    this.activeName = this.$route.name
    this.feeType = this.$route.params.type
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      // eslint-disable-next-line eqeqeq
      if (activeName == oldActiveName) {
        return false
      // eslint-disable-next-line eqeqeq
      } else if (activeName != 'FeePeriodList' && this.noPeriod) { // 期別列表為空 限制只能前往期別列表
        this.$router.push({ name: 'FeePeriodList', params: { type: this.feeType } })
        this.$message({
          message: '請先新增期別',
          type: 'warning'
        })
        return false
      // eslint-disable-next-line eqeqeq
      } else if (activeName == 'FeePaymentList') { // 到繳費列表未獲得期別id 則重新取得並賦值
        if (!this.$route.params.id) {
          this.$router.push({ name: activeName, params: { type: this.feeType, id: this.periodDataNew } })
        }
      } else {
        // 如果是從瀏覽器按上一頁，則不需要我們手動去push route，瀏覽器已導向需要去的頁面
        if (activeName !== this.$route.name) {
          this.$router.push({ name: activeName, params: { type: this.feeType } })
        }
      }
    },
    handleTabClick (tab, event) {
      switch (tab.paneName) {
        case 'FeePeriodList':
          this.$emit('updatePeriod')
          break
        default:
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#feeTab
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
